import { ReactElement, SVGAttributes, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@components/new/Tooltip';
import { Badge, BadgeType } from "@components/new/Badge";
import NeutralIcon from "@assets/icons/solid/circle-info.svg?react";
import SuccessIcon from "@assets/icons/solid/circle-check.svg?react";

const StatusBadge = ({ value }: {
  value?: string;
}): ReactElement => {
  const { t } = useTranslation();

  const getStatusType = (status: string) => {
    const statuses: Record<string, BadgeType> = {
      Created: BadgeType.SECONDARY,
      Accepted: BadgeType.PRIMARY,
      WarehouseReceiving: BadgeType.PRIMARY,
      PartiallyCompleted: BadgeType.PRIMARY,
      Completed: BadgeType.PRIMARY,
      Cancelled: BadgeType.DESTRUCTIVE,
      Rejected: BadgeType.DESTRUCTIVE,
      OnWay: BadgeType.PRIMARY,

      // withdrawal statuses
      // Created: BadgeType.PRIMARY,
      // Accepted: BadgeType.PRIMARY,
      Assembled: BadgeType.PRIMARY,
      // Completed: BadgeType.PRIMARY,
      // Canceled: BadgeType.DESTRUCTIVE,
      Destroyed: BadgeType.DESTRUCTIVE,
    }
    return statuses[status] ?? BadgeType.SECONDARY;
  }

  const getStatusIcon = (status: string) => {
    const statuses: Record<string, FunctionComponent<SVGAttributes<SVGElement>>> = {
      Completed: SuccessIcon,
      Rejected: NeutralIcon,
    }
    return statuses[status] ?? null;
  }

  return (
    <Tooltip
      action={
        <Badge
          type={getStatusType(value ?? "")}
          iconLeft={getStatusIcon(value ?? "")}
        >
          {t(`fbpPage.orderStatuses.${value}`)}
        </Badge>
      }
      position="top"
      text={""}
    />
  );
};

export default StatusBadge;
